
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"x":"-58.3%","y":"-58.3%","width":"216.7%","height":"216.7%","filterUnits":"objectBoundingBox","id":"a"}},[_c('feOffset',{attrs:{"dy":"1","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2","in":"shadowOffsetOuter1","result":"shadowBlurOuter1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0","in":"shadowBlurOuter1","result":"shadowMatrixOuter1"}}),_c('feMerge',[_c('feMergeNode',{attrs:{"in":"shadowMatrixOuter1"}}),_c('feMergeNode',{attrs:{"in":"SourceGraphic"}})])])]),_c('g',{attrs:{"filter":"url(#a)","transform":"translate(2 1)","fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"d":"M9 0C4.037 0 0 4.037 0 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M11.642 9.35H9.35v2.292a.353.353 0 01-.705 0V9.35H6.353a.353.353 0 010-.705h2.292V6.353a.353.353 0 01.705 0v2.292h2.292a.353.353 0 010 .705z","fill":"#23292E"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/tabs/network/more.svg